import React, { useEffect, useState, useRef, useMemo } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
//import './Aa000HomePageStyle.css';
import ApiSender from '../common/ApiLogic';
import useOtpSendThrottle, { OTP_SEND_COOLDOWN_MS } from '../common/useOtpSendThrottle';
import { logger } from '../common/utils/logger';

function Aa000HomePage() {

  const [goalId, setGoalId] = useState(null);
  const [goalName, setGoalName] = useState(null);
  const nav = useNavigate();
  const location = useLocation();
  const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const otpContainerRef = useRef();
  const [language, setLanguage] = useState('EN');
  const [msisdn, setMsisdn] = useState(null);
  const [warning, setWarning] = useState(false);
  const [otp, setOtp] = useState(null);
  const [isGradient, setIsGradient] = useState(false);
  const [firstStep, setFirstStep] = useState(true);
  const [secondStep, setSecondStep] = useState(false);
  const otpThrottle = useOtpSendThrottle();
  const sendInFlightRef = useRef(false);
  const params = new URLSearchParams(location.search);
  const paramsObject = {};
  for (const [key, value] of params.entries()) {
    paramsObject[key] = value;
  }

  useEffect(() => {
    if (queryParams.has("campaignId")) {
      const fetchData = async () => {
        try {
          const response = await fetch(process.env.REACT_APP_GOOGLE_BASE_URL + 'campaign/info?uuid=' + queryParams.get("campaignId"),
            {
              method: 'GET',
              headers: {
                "Content-Type": "application/json"
              }
            });
          if (response.ok) {
            const data = await response.json();
            const status = data.status;
            if (status) {
              setGoalId(data.goalId);
              setGoalName(data.goalName);
            }
          }
        }
        catch (error) {
        }
      }
      fetchData();
    }
  }, []);

  useEffect(() => {
    saveHistory();
  }, []);

  const saveHistory = async () => {
    const apiSender = new ApiSender();
    await apiSender.saveHistory(window.location.origin + location.pathname, paramsObject);
  }

  useEffect(() => {
    if (secondStep && otpContainerRef.current) {
      otpContainerRef.current.focus();
    }
  }, [secondStep]);


  const handleLanguage = (event) => {
    const selectedLang = event.target.textContent.trim();
    setLanguage(selectedLang === 'English' ? 'EN' : 'AR');
    setIsGradient(selectedLang === 'English' ? true : false);
  };

  const gradientStyle = {
    background: isGradient
      ? 'linear-gradient(to right, rgba(103, 193, 98, 0.4) 50%, rgba(103, 193, 98, 1) 50%)'
      : 'linear-gradient(to left, rgba(103, 193, 98, 0.4) 50%, rgba(103, 193, 98, 1) 50%)',
  };

  const handleMsisdnChange = (event) => {
    const newMsisdn = event.target.value;
    setMsisdn(newMsisdn);
    document.getElementById('country-code').style.color = 'black';
    setWarning(false);
  }

  const handleMsisdnFocus = () => {
    document.getElementById('country-code').style.color = 'black';
  }

  const handleMsisdnBlur = () => {
    if (msisdn === null || msisdn === undefined || msisdn.length === 0) {
      document.getElementById('country-code').style.color = '#999';
    }
  }

  const handleOtpChange = (event) => {
    document.getElementById('otp-input').style.border = '';
    const newOtp = event.target.value;
    setOtp(newOtp);
  };

  const handleSendOtpClick = async () => {
    // Rejects a second call while one is already in flight — the cooldown/
    // failure-count checks above only update after each API call resolves,
    // so overlapping rapid clicks (faster than the round-trip) could
    // otherwise all pass isOnCooldown() before the first one's failure is
    // even recorded.
    if (sendInFlightRef.current) return;
    if (otpThrottle.isOnCooldown()) {
      const secs = otpThrottle.cooldownSecondsLeft();
      document.getElementById('warning-msg').textContent = language === 'EN' ? `Too many attempts. Please try again in ${secs}s.` : `عدد كبير جدًا من المحاولات. يرجى المحاولة مرة أخرى خلال ${secs} ثانية.`;
      setWarning(true);
      return;
    }

    if (!isMsisdnValid(msisdn)) {
      document.getElementById('warning-msg').textContent = language === 'EN' ? 'Incorrect Number Format' : 'رقم غير صحيح';
      setWarning(true);
      return;
    }

    if (!isMsisdnSupported(msisdn)) {
      document.getElementById('warning-msg').textContent = language === 'EN' ? 'Phone Number Not Supported' : 'رقم هاتف غير معتمد';
      setWarning(true);
      return;
    }

    sendInFlightRef.current = true;
    document.getElementById('loading-spinner-send').style.display = 'inline-flex';
    document.getElementById('send-otp-btn').disabled = true;
    let operatorId = null;
    if (isStc(msisdn)) {
      operatorId = 1;
    }
    if (isMobily(msisdn)) {
      operatorId = 2;
    }
    if (isRedbull(msisdn)) {
      operatorId = 7;
    }
    if (isZain(msisdn)) {
      operatorId = 8;
    }

    const campaignId = queryParams.get("campaignId") ? queryParams.get("campaignId") : null;
    const trackerId = queryParams.get("trackerId") ? queryParams.get("trackerId") : null;
    const gclid = queryParams.get("gclid") ? queryParams.get("gclid") : null;
    const gbraid = queryParams.get("gbraid") ? queryParams.get("gbraid") : null;
    const wbraid = queryParams.get("wbraid") ? queryParams.get("wbraid") : null;
    const apiSender = new ApiSender();
    const result = await apiSender.sendPin('send-pin', msisdn, campaignId, language, trackerId, gclid, gbraid, wbraid, goalId, goalName,
      window.location.origin + location.pathname, "LP AA000", operatorId, paramsObject);
    if (result.success) {
      otpThrottle.recordSuccess();
      sendInFlightRef.current = false;
      if (result.redirect !== null && result.redirect !== undefined) {
        window.location.href = result.redirect;
        return;
      }
      document.getElementById('loading-spinner-send').style.display = 'none';
      document.getElementById('send-otp-btn').disabled = false;
      setWarning(false);
      setFirstStep(false);
      setSecondStep(true);
      document.getElementById('send-otp-btn').style.display = 'none';
      document.getElementById('verify-otp-btn').style.display = 'block';
      document.getElementById('msisdn-input').style.display = 'none';
      document.getElementById('otp-input-container').style.display = 'flex';
      document.getElementById('title').textContent = language === 'EN' ? 'Enter your OTP' : 'ادخل الرقم السري';
      return;
    }
    sendInFlightRef.current = false;
    document.getElementById('loading-spinner-send').style.display = 'none';
    const enteredCooldown = otpThrottle.recordFailure();
    if (enteredCooldown) {
      logger.warn("send_otp", "throttled", `Send-OTP cooldown triggered for ${msisdn} after repeated failures`, { msisdn, cooldownMs: OTP_SEND_COOLDOWN_MS });
    }
    const message = enteredCooldown
      ? (language === 'EN' ? `Too many failed attempts. Please try again in ${otpThrottle.cooldownSecondsLeft()}s.` : `عدد كبير جدًا من المحاولات الفاشلة. يرجى المحاولة مرة أخرى خلال ${otpThrottle.cooldownSecondsLeft()} ثانية.`)
      : result.message;
    setWarning(true);
    document.getElementById('warning-msg').textContent = message;
    if (enteredCooldown) {
      setTimeout(() => {
        const btn = document.getElementById('send-otp-btn');
        if (btn) btn.disabled = false;
      }, OTP_SEND_COOLDOWN_MS);
    } else {
      document.getElementById('send-otp-btn').disabled = false;
    }
  }

  const handleVerifyOtpClick = async () => {
    const o = otp;
    if (o === null || o === 'undefined' || (o.length !== 4 && o.length !== 6)) {
      document.getElementById('otp-input').style.border = "2px solid rgb(103, 193, 98)";
      return;
    }

    let operatorId = null;
    if (isStc(msisdn)) {
      operatorId = 1;
    }
    if (isMobily(msisdn)) {
      operatorId = 2;
      if (o === '607110') {
        document.getElementById('warning-msg-div').classList.add('active');
        document.getElementById('warning-msg').textContent = language === 'EN' ? 'Enter the correct code you see in the SMS received' : 'أدخل الرمز الصحيح الذي تراه في الرسالة النصية المستلمة';
        return;
      }
    }
    if (isRedbull(msisdn)) {
      operatorId = 7;
    }
    if (isZain(msisdn)) {
      operatorId = 8;
    }

    document.getElementById('loading-spinner-verify').style.display = 'inline-flex';
    document.getElementById('verify-otp-btn').disabled = true;
    const campaignId = queryParams.get("campaignId") ? queryParams.get("campaignId") : null;
    const trackerId = queryParams.get("trackerId") ? queryParams.get("trackerId") : null;
    const gclid = queryParams.get("gclid") ? queryParams.get("gclid") : null;
    const gbraid = queryParams.get("gbraid") ? queryParams.get("gbraid") : null;
    const wbraid = queryParams.get("wbraid") ? queryParams.get("wbraid") : null;
    const apiSender = new ApiSender();
    const result = await apiSender.verifyPin('verify-pin', msisdn, o, campaignId, language, trackerId, gclid, gbraid, wbraid, goalId, goalName,
      window.location.origin + location.pathname, "LP AA000", operatorId);
    if (result.success) {
      nav('/aa000/success?lang=' + language);
      document.getElementById('warning-msg-div').classList.add('active');
      document.getElementById('warning-msg').textContent = result.message;
      document.getElementById('verify-otp-btn').disabled = false;
      document.getElementById('loading-spinner-verify').style.display = 'none';
      return;
    }
    setWarning(true);
    setOtp('');
    document.getElementById('warning-msg').textContent = result.message;
    document.getElementById('verify-otp-btn').disabled = false;
    document.getElementById('loading-spinner-verify').style.display = 'none';
  }

  const isMsisdnSupported = (msisdn) => {
    if (msisdn !== null && msisdn !== undefined) {
      return isMobily(msisdn) || isRedbull(msisdn);
    }
    return false;
  }

  const isMsisdnValid = (msisdn) => {
    if (msisdn !== null && msisdn !== undefined) {
      return (msisdn.length === 9);
    }
    return false;
  }

  const isStc = (msisdn) => {
    if (msisdn !== null && msisdn !== undefined) {
      return (msisdn.length === 12 && (msisdn.startsWith('96650') || msisdn.startsWith('96653') || msisdn.startsWith('96655')))
        || (msisdn.length === 9 && (msisdn.startsWith('50') || msisdn.startsWith('53') || msisdn.startsWith('55')));
    }
    return false;
  }

  const isMobily = (msisdn) => {
    if (msisdn !== null && msisdn !== undefined) {
      return (msisdn.length === 12 && (msisdn.startsWith('96654') || msisdn.startsWith('96656')))
        || (msisdn.length === 9 && (msisdn.startsWith('54') || msisdn.startsWith('56')));
    }
    return false;
  }

  const isRedbull = (msisdn) => {
    if (msisdn !== null && msisdn !== undefined) {
      return (msisdn.length === 12 && (msisdn.startsWith('966574') || msisdn.startsWith('966575')))
        || (msisdn.length === 9 && (msisdn.startsWith('574') || msisdn.startsWith('575')));
    }
    return false;
  }

  const isZain = (msisdn) => {
    if (msisdn !== null && msisdn !== undefined) {
      return (msisdn.length === 12 && (msisdn.startsWith('96658') || msisdn.startsWith('96659')))
        || (msisdn.length === 9 && (msisdn.startsWith('58') || msisdn.startsWith('59')));
    }
    return false;
  }

  return (
    <div className="Aa000">
      <div className='container'>
        <div className='header'>
          <div className='header-left'>
            <div className="language" style={gradientStyle} onClick={handleLanguage}>
              <div className='language-left'>
                <span>عربي</span>
              </div>
              <div className='language-middle'>
                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeWidth="2" d="M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M12,23 C15,23 16,18 16,12 C16,6 15,1 12,1 C9,1 8,6 8,12 C8,18 9,23 12,23 Z M2,16 L22,16 M2,8 L22,8"></path></svg>
              </div>
              <div className='language-right'>
                <span>English</span>
              </div>
            </div>
          </div>
          <div className='header-right'>
            <div className='logo'><img fetchpriority='high' alt='Kid Security' src='/kid-security-logo-en.avif' /></div>
          </div>
        </div>
        <div className='form-content'>
          <div className='title'>
            <h4 id='headup-title'>{language === 'EN' ? 'Download Parental Control Application' : 'تنزيل تطبيق الرقابة الأبوية'}</h4>
          </div>
          <div className='form-content-top'>
            <div className='logo'><img fetchpriority='high' alt='Kid Security' src='/phone-icon.avif' /></div>
          </div>
          <div className='form-content-middle'>
            <div className='title'>
              <h4 id='title'>{secondStep ?
                (language === 'EN' ? 'Enter your OTP' : 'ادخل الرقم السري') :
                (language === 'EN' ? 'Enter your mobile number' : 'ادخل رقم هاتفك المحمول')}</h4>
            </div>
            <div className='arrows' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '1.25rem' }}>
              {firstStep && <svg fill="#000000" height="2rem" width="2rem" viewBox="0 0 330 330" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" xmlSpace="preserve"><path d="M15,180h263.787l-49.394,49.394c-5.858,5.857-5.858,15.355,0,21.213C232.322,253.535,236.161,255,240,255 s7.678-1.465,10.606-4.394l75-75c5.858-5.857,5.858-15.355,0-21.213l-75-75c-5.857-5.857-15.355-5.857-21.213,0 c-5.858,5.857-5.858,15.355,0,21.213L278.787,150H15c-8.284,0-15,6.716-15,15S6.716,180,15,180z" /></svg>}
              <div id='msisdn-input' className={`input ${warning ? 'vibrate' : ''}`}>
                <span id='country-code' className='country-code'>+966</span>
                <input type='tel' value={msisdn} placeholder='5xxxxxxxx' autoComplete='off' minLength={9} maxLength={9} required onChange={handleMsisdnChange} onFocus={handleMsisdnFocus} onBlur={handleMsisdnBlur} />
                <div className='phone-logo'>
                  <img fetchpriority='high' alt='' src='/phone-logo.avif' />
                </div>
              </div>
              {firstStep && <svg fill="#000000" height="2rem" width="2rem" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 400.004 400.004" xmlSpace="preserve"><g><path d="M382.688,182.686H59.116l77.209-77.214c6.764-6.76,6.764-17.726,0-24.485c-6.764-6.764-17.73-6.764-24.484,0L5.073,187.757 c-6.764,6.76-6.764,17.727,0,24.485l106.768,106.775c3.381,3.383,7.812,5.072,12.242,5.072c4.43,0,8.861-1.689,12.242-5.072 c6.764-6.76,6.764-17.726,0-24.484l-77.209-77.218h323.572c9.562,0,17.316-7.753,17.316-17.315 C400.004,190.438,392.251,182.686,382.688,182.686z" /></g></svg>}
            </div>
            <div id='warning-msg-div' className={`warning-msg ${warning ? 'active' : ''}`}>
              <span id='warning-msg'>&nbsp;</span>
            </div>
            <div id='otp-input-container' className='otp-input-container'>
              <input id='otp-input' type="tel" minLength={4} maxLength={6} value={otp} onChange={handleOtpChange} className="otp-input"
                autoComplete="off" ref={otpContainerRef} />
            </div>
            <div className='button'>
              <button id='send-otp-btn' style={{ display: 'block' }} onClick={handleSendOtpClick}>
                {language === 'EN' ? 'Subscribe' : 'اشترك'}
                <div id="loading-spinner-send" class="spinner"></div>
              </button>
              <button id='verify-otp-btn' style={{ display: 'none' }} onClick={handleVerifyOtpClick}>
                {language === 'EN' ? 'Subscribe' : 'اشترك'}
                <div id="loading-spinner-verify" class="spinner"></div>
              </button>
              <span>{language === 'EN' ? '' : ''}</span>
            </div>
          </div>
          <div className='form-content-bottom' style={{ direction: language === 'EN' ? "ltr" : "rtl" }}>
            {language === 'EN' ? (
              <span>
                Kid Security is a subscription service available for Mobily Subscribers for 2.3 Riyal daily with a 1-day free trial for the first subscription (VAT Included). VAT Tax was already paid with a refill card for prepaid subscribers. To unsubscribe, send U58 to 607110. For Redbull Subscribers, the service is available for 1.725 SAR per day (VAT Included). To unsubscribe, send CB517 to 143334
              </span>
            ) : (
              <span>
                امان الأطفال هي خدمة اشتراك متوفرة لمشتركي موبايلي مقابل 2.3 ريال يوميًا، مع تجربة مجانية لمدة يوم واحد عند الاشتراك لأول مرة (شامل ضريبة القيمة المضافة). تم دفع ضريبة القيمة المضافة بالفعل من خلال بطاقة إعادة الشحن للمشتركين بنظام الدفع المسبق. لإلغاء الاشتراك، أرسل U58 إلى 607110.
                بالنسبة لمشتركي ريد بول، الخدمة متاحة مقابل 1.725 ريال سعودي يوميًا (شامل ضريبة القيمة المضافة). لإلغاء الاشتراك، أرسل CB517 إلى 143334.
              </span>
            )}
          </div>
          <div className='form-content-footer'>
            <Link to={`/aa000/terms?lang=${language}`}>{language === 'AR' ? (<a>أحكام وشروط</a>) : (<a>Terms and Condition</a>)}</Link>
            <svg fill="#000000" width="1em" height="1em" viewBox="-6.5 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M8.469-1.156h2.25v29.813h-2.25v-29.813z"></path></svg>
            {language === 'AR' ? (<a href='mailto:support@kid-security.io'>للتواصل انقر هنا</a>) : (<a href='mailto:support@kid-security.io'>Contact Us</a>)}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Aa000HomePage;
